// extracted by mini-css-extract-plugin
export default {"vendorType":"vendorType__YjhkZ","withRating":"withRating__M2Q3O","ratingStars":"ratingStars__NzUwY","typeLocation":"typeLocation__YTFhO","dot":"dot__ZWQ2O"};